export default "__VITE_ASSET__B1c6_Bgy__"